export const reviewsPluginTs = `import { PluginCommonModule, VendurePlugin } from '@vendure/core'
import { AdminUiExtension } from '@vendure/ui-devkit/compiler'

import { Review } from './entities/review.entity'
import { ReviewService } from './services/review.service'
import { reviewAdminApiExtensions } from './api/admin-api-extensions'
import { reviewShopApiExtensions } from './api/shop-api-extensions'
import { AdminApiResolver } from './api/admin-api.resolver'
import { ShopApiResolver } from './api/shop-api.resolver'

/**
 * This is a Vendure plugin which extends the functionality of the Vendure server
 * by adding a product review system. It demonstrates how to:
 *
 * 1. Define custom database entities
 * 2. Create services for business logic
 * 3. Extend the GraphQL API with custom queries and mutations
 * 4. Extend the Admin UI with custom views (commented out for demo)
 */
@VendurePlugin({
  imports: [PluginCommonModule],
  entities: [Review],
  providers: [ReviewService],
  adminApiExtensions: {
    schema: reviewAdminApiExtensions,
    resolvers: [AdminApiResolver],
  },
  shopApiExtensions: {
    schema: reviewShopApiExtensions,
    resolvers: [ShopApiResolver],
  },
  configuration: (config) => {
    // Plugin configuration can be added here
    return config
  },
})
export class ReviewsPlugin {
  static options: any = {}

  static init(options: any) {
    this.options = options
    return ReviewsPlugin
  }
}

/**
 * This is an example of how to extend the Admin UI with custom components.
 * For the demo, we'll comment this out since it requires additional setup.
 */
// export const reviewsAdminUiExtensions: AdminUiExtension = {
//   extensionPath: path.join(__dirname, 'ui'),
//   providers: ['providers.ts'],
//   routes: [
//     {
//       route: 'reviews',
//       filePath: 'routes.ts',
//       routeModule: {
//         RouteModuleComponent: 'ReviewsComponent',
//       },
//     },
//   ],
// }
`
